import type { PortMessage, UserProfile } from '@yoop/whitelabel-data';
import type { StateCreator } from 'zustand/vanilla';
import { createStore } from 'zustand/vanilla';

interface UserSlice {
  currentUser: UserProfile | undefined;
  // Accepts undefined: clearing the current user is a first-class state, used on logout, on an
  // unauthorized response, and when the initial profile fetch fails.
  updateCurrentUser: (user: UserProfile | undefined) => void;
}

const createUserSlice: StateCreator<UserSlice> = (set) => ({
  currentUser: undefined,
  updateCurrentUser: (newUser: UserProfile | undefined) => set({ currentUser: newUser }),
});

interface ConfigSlice {
  clientId: number | undefined;
  updateClient: (id: number) => void;
}

const createConfigSlice: StateCreator<ConfigSlice> = (set) => ({
  clientId: undefined,
  updateClient: (id) => set({ clientId: id }),
});

export const appStore = createStore<UserSlice & ConfigSlice>((...params) => ({
  ...createUserSlice(...params),
  ...createConfigSlice(...params),
}));

interface SendDataParams {
  action: string;
  key: string;
  getData: () => Promise<any>;
}
interface CommunicationStore {
  messageChannel: MessageChannel;
  sendMessage: (message: PortMessage) => void;
  sendDataMessage: (params: SendDataParams) => void;
}

export const communicationStore = createStore<CommunicationStore>((setState, getState) => ({
  messageChannel: new MessageChannel(),
  sendMessage: (message) => getState().messageChannel.port1.postMessage(message),
  sendDataMessage: async ({ action, key, getData }) => {
    let payload: PortMessage | undefined;
    try {
      const data = await getData();
      payload = {
        action,
        key,
        data: {
          success: true,
          result: data,
        },
      };
    } catch (error) {
      payload = {
        action,
        key,
        data: {
          success: false,
          error: error as any,
        },
      };
    } finally {
      if (payload) {
        getState().messageChannel.port1.postMessage(payload);
      }
    }
  },
}));
